<template lang="pug">
	section
		p.mb-5
			| Knowing this helps us better customize your experience and offer better recommendations
		div.mb-5
			sfc-select-wrapper.select-wrapper(:errorMessage="''" :error="false" :flat="false")
				select(v-model="stateOfResidence")
					option(value="-" disabled hidden) Select your state
					option(v-for="state of states" :key="state.id" v-bind:value="state") {{state.name}}
		br
		.continue-button.mt-2
			sfc-button(text="NEXT" :blue="true" :continue-arrow="true" @click="next()")

</template>

<style lang="stylus" scoped>
.select-wrapper
	>>> select
		@media(max-width: 575px)
			font-size: body-font-size-md
</style>



<script>
import SfcButton from '@/common/components/sfc-button'
import SfcTrackingService from "@/lib/sfc-tracking-service"

export default {

	components:{
		SfcButton
	},

	props: {
		forceMobile: {
			default: false
		}
	},

	data() {
		return {
			stateOfResidence: "-",
			states: this.$store.state.states,
			savingsUser: null,
			error: false,
			errorMessage: "Please choose your state",
			loading: false,
			progressLength: 25
		}
	},

	mounted(){
		this.stateOfResidence = {
			id: this.$store.state.stateFromIp.sfc_id,
			name: this.$store.state.stateFromIp.name,
			string_id: this.$store.state.stateFromIp.id
		}
	},

	methods: {
		setState(state){
			if(!state) return

			this.$store.commit(
				'updateCollegeSavingsUserOnboarding',
				{
					part: "state",
					value: state
				}
			)
		},
		
		next(){
			SfcTrackingService.trackAnalyticsAction("Savings Center Onboarding", "What is your state? - next", "", 0)
			this.setState(this.stateOfResidence)
			this.$emit('next', this.progressLength, "Who are you saving for?", "sfc-who-are-you-saving-for")
		},
	}
}
</script>
